<div class="card">
    <div class="container">
        <div class="d-flex" (click)="toggle()">
            <div class="column label">
                <div class="d-flex align-items-center">
                    <span class="status-circle mr-2"
                        [ngClass]="{
                            'filled': item().value.classification && item().value.classification !== 'NON_EXISTENT',
                            'good': item().value.classification === 'GOOD',
                            'regular': item().value.classification === 'REGULAR',
                            'bad': item().value.classification === 'BAD'
                        }"></span>
                    <div class="item-info">
                        <div class="d-flex align-items-center">
                            <span class="item-name">{{ item().value.name }}</span>
                            @if (required()) {
                                <span class="ml-2 required-badge">OBRIGATÓRIO</span>
                            }
                        </div>
                        @if (item().value.classification === 'GOOD') {
                            <span class="status-text good">Bom estado</span>
                        } @else if (item().value.classification === 'REGULAR') {
                            <span class="status-text regular">Regular</span>
                        } @else if (item().value.classification === 'BAD') {
                            <span class="status-text bad">Ruim</span>
                        }
                    </div>
                </div>
            </div>

            <div class="column options">
                <button type="button" class="option-btn"
                    [ngClass]="{'good-selected': item().value.classification == 'GOOD'}"
                    (click)="selectOption('GOOD'); $event.stopPropagation()">
                    <span class="material-icons">check</span>
                </button>
                <button type="button" class="option-btn"
                    [ngClass]="{'regular-selected': item().value.classification == 'REGULAR'}"
                    (click)="selectOption('REGULAR'); $event.stopPropagation()">
                    <span class="material-icons">remove</span>
                </button>
                <button type="button" class="option-btn"
                    [ngClass]="{'bad-selected': item().value.classification == 'BAD'}"
                    (click)="selectOption('BAD'); $event.stopPropagation()">
                    <span class="material-icons">close</span>
                </button>
            </div>

            <div class="column arrow">
                <span class="material-icons pointer">
                    {{ opened() ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                </span>
            </div>
        </div>

        <div class="row comments-and-cost" [@expandCollapse]="opened() ? 'expanded' : 'collapsed'"
            (@expandCollapse.done)="onAnimationDone($event)" (@expandCollapse.start)="onAnimationStart($event)">
            @if (key() !== 'TIRES' || !axles()?.length) {
                <div class="expanded-content w-100">
                    <!-- Condição -->
                    <div class="condition-section">
                        <label class="section-label-condition">Condição</label>
                        <div class="condition-buttons">
                            <button type="button" class="condition-btn good"
                                [ngClass]="{'selected': item().value.classification == 'GOOD'}"
                                (click)="selectOption('GOOD');">
                                Bom
                            </button>
                            <button type="button" class="condition-btn regular"
                                [ngClass]="{'selected': item().value.classification == 'REGULAR'}"
                                (click)="selectOption('REGULAR');">
                                Regular
                            </button>
                            <button type="button" class="condition-btn bad"
                                [ngClass]="{'selected': item().value.classification == 'BAD'}"
                                (click)="selectOption('BAD')">
                                Ruim
                            </button>
                        </div>
                    </div>

                    <!-- Comentário -->
                    <div class="comment-section">
                        <label class="section-label">Comentário</label>
                        <input type="text" class="form-control comment-input"
                            [ngModel]="comments()" (ngModelChange)="comments.set($event)" [ngModelOptions]="{standalone: true}"
                            (blur)="onBlur()"
                            placeholder="Descreva o comentário do veículo">
                    </div>

                    <!-- Custo Estimado -->
                    <div class="cost-section">
                        <label class="section-label">Custo Estimado (R$)</label>
                        <div class="cost-row">
                            <input type="text" class="form-control cost-input"
                                [ngModel]="estimatedCost()" (ngModelChange)="estimatedCost.set($event)" [ngModelOptions]="{standalone: true}"
                                (blur)="onBlur()" currencyMask [options]="{
                                    prefix: 'R$ ',
                                    thousands: '.',
                                    precision: 2,
                                    allowNegative: false
                                }">
                            <div class="media-icons">
                                <button type="button" class="media-btn" (click)="openModalUploadPhoto('photo')">
                                    <span class="material-icons">photo_camera</span>
                                    @if (imgQty() > 0) {
                                        <span class="media-badge">{{ imgQty() }}</span>
                                    }
                                </button>
                                <button type="button" class="media-btn" (click)="openModalUploadPhoto('video')">
                                    <span class="material-icons">videocam</span>
                                    @if (videoQty() > 0) {
                                        <span class="media-badge">{{ videoQty() }}</span>
                                    }
                                </button>
                                <button type="button" class="media-btn" (click)="openModalUploadAudio()">
                                    <span class="material-icons">mic</span>
                                    @if (audioQty() > 0) {
                                        <span class="media-badge">{{ audioQty() }}</span>
                                    }
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            } @else {
                <div class="expanded-content w-100">
                    <div class="col-md-12 mb-3">
                        <span class="tires-description">Toque no pneu e atribua uma condição para cada um deles.</span>
                    </div>
                    <div class="row justify-content-between">
                        <div class="col-12 col-md-4">
                            @for (axle of axles(); track axle.position; let i = $index) {
                            <app-evaluation-axle [index]="i" [activeAxle]="axle.tireCount == 4" [quantityTires]="axle.tireCount"
                                [isReportItem]="true" [tiresFormArray]="tiresByAxle().get(i + 1)">
                            </app-evaluation-axle>
                            }
                        </div>
                        <div class="col-12 col-md-6 d-flex flex-column justify-content-end">
                            <!-- Comentário -->
                            <div class="comment-section">
                                <label class="section-label">Comentário</label>
                                <input type="text" class="form-control comment-input"
                                    [(ngModel)]="comments" [ngModelOptions]="{standalone: true}"
                                    (blur)="onBlur()"
                                    placeholder="Descreva o comentário do veículo">
                            </div>

                            <!-- Custo Estimado -->
                            <div class="cost-section">
                                <label class="section-label">Custo Estimado (R$)</label>
                                <div class="cost-row">
                                    <input type="text" class="form-control cost-input"
                                        [ngModel]="estimatedCost()" (ngModelChange)="estimatedCost.set($event)" [ngModelOptions]="{standalone: true}"
                                        (blur)="onBlur()" currencyMask [options]="{
                                            prefix: 'R$ ',
                                            thousands: '.',
                                            precision: 2,
                                            allowNegative: false
                                        }">
                                    <div class="media-icons">
                                        <button type="button" class="media-btn" (click)="openModalUploadPhoto('photo')">
                                            <span class="material-icons">photo_camera</span>
                                            @if (imgQty() > 0) {
                                                <span class="media-badge">{{ imgQty() }}</span>
                                            }
                                        </button>
                                        <button type="button" class="media-btn" (click)="openModalUploadPhoto('video')">
                                            <span class="material-icons">videocam</span>
                                            @if (videoQty() > 0) {
                                                <span class="media-badge">{{ videoQty() }}</span>
                                            }
                                        </button>
                                        <button type="button" class="media-btn" (click)="openModalUploadAudio()">
                                            <span class="material-icons">mic</span>
                                            @if (audioQty() > 0) {
                                                <span class="media-badge">{{ audioQty() }}</span>
                                            }
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
